import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';

//링크들
import Home from './_pages/Home';
import Post from './_pages/Post';
import ETC from './_pages/ETC';


//라우팅
function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/Post" component={Post} />
        <Route exact path="/ETC" component={ETC} />
      </Switch>
    </Router>
  );
}

export default App;
